// @ts-ignore
/* eslint-disable */
import request from '../../../requestInstance';
import { CommonResult } from '@/services/CommonType';
import type {
  EmployeeListResponse,
  EmployeeListInitRequest,
  EmployeeListSearchRequest,
} from './types';

/**
 * 员工列表初始化
 * GET /human-resources/employee-list/init
 * 权限：cbbm_hr102:init:view
 * 用途：返回社员情报一览的初始化信息（不分页）
 */
export async function getEmployeeListInit(
  params?: EmployeeListInitRequest,
  options?: { [key: string]: any },
): Promise<CommonResult<EmployeeListResponse>> {
  return request<CommonResult<EmployeeListResponse>>('/api/human-resources/employee-list/init', {
    method: 'GET',
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    ...(options || {}),
  });
}

/**
 * 员工列表搜索
 * GET /human-resources/employee-list/search
 * 权限：cbbm_hr102:employee:search
 * 用途：按条件检索员工列表（不分页）
 */
export async function searchEmployeeList(
  params: EmployeeListSearchRequest,
  options?: { [key: string]: any },
): Promise<CommonResult<EmployeeListResponse>> {
  return request<CommonResult<EmployeeListResponse>>('/api/human-resources/employee-list/search', {
    method: 'GET',
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token') || ''}`,
    },
    ...(options || {}),
  });
}
